import { useEffect, useState } from "react";
import { Form, Button, Row, Container, Col } from "react-bootstrap";
import { GenericForm } from "../../Component/GenericForm/GenericForm";
import { Api } from "../../Helpers/axios/axios";
import { formInterface } from "../../Component/GenericForm/formInterface";
import { useNavigate, useParams } from "react-router-dom";
import { PageHeader } from "../../Component/Common/Headers";
import { LoadingSpinner } from "../../Component/Spinner/LoadingSpinner";
import { FileUpload } from "../../Component/FileUpload/FileUpload";
import { MapLocationPicker } from "../../Component/Common/MapLocationPicker";
import { SeoFormSection } from "../../Component/Common/SeoFormSection";

export const UniversityForm = () => {
    const url = "/universities"
    const navigate = useNavigate();
    const { id } = useParams();

    const [programsList, setProgramsList] = useState<any[]>([]);

    useEffect(() => {
        Api.post("/programs/withPagination", { limit: 1000, page: 1 }).then((res: any) => {
            const list = res?.data?.data?.data || res?.data?.data || res?.data || [];
            if (Array.isArray(list)) {
                setProgramsList(list.map((p: any) => ({ label: p.name, value: p.id })));
            }
        });
    }, []);

    const accreditationOptions = [
        { label: "UGC", value: "UGC" },
        { label: "NAAC A++", value: "NAAC A++" },
        { label: "NAAC A+", value: "NAAC A+" },
        { label: "NAAC A", value: "NAAC A" },
        { label: "AICTE", value: "AICTE" },
        { label: "DEB", value: "DEB" },
        { label: "WES", value: "WES" },
        { label: "AIU", value: "AIU" },
        { label: "AACSB", value: "AACSB" }
    ];

    const stateOptions = [
        "Andhra Pradesh",
        "Arunachal Pradesh",
        "Assam",
        "Bihar",
        "Chhattisgarh",
        "Goa",
        "Gujarat",
        "Haryana",
        "Himachal Pradesh",
        "Jharkhand",
        "Karnataka",
        "Kerala",
        "Madhya Pradesh",
        "Maharashtra",
        "Manipur",
        "Meghalaya",
        "Mizoram",
        "Nagaland",
        "Odisha",
        "Punjab",
        "Rajasthan",
        "Sikkim",
        "Tamil Nadu",
        "Telangana",
        "Tripura",
        "Uttar Pradesh",
        "Uttarakhand",
        "West Bengal",
        "Andaman and Nicobar Islands",
        "Chandigarh",
        "Dadra and Nagar Haveli and Daman and Diu",
        "Delhi",
        "Jammu and Kashmir",
        "Ladakh",
        "Lakshadweep",
        "Puducherry"
    ].map(s => ({ label: s, value: s }));

    const universityTypeOptions = [
        { label: "Private", value: "Private" },
        { label: "Government", value: "Government" }
    ];

    //Form Data
    const config: formInterface[] = [
        { type: "text", name: "Name", key: "name", require: true, md: 6 },
        { type: "text", name: "Slug", key: "slug", require: true, md: 6 },
        { type: "select", name: "Type", key: "type", require: true, md: 6, options: universityTypeOptions, placeholder: "Select University Type" },
        { type: "select", name: "State", key: "state", require: false, md: 6, options: stateOptions, placeholder: "Select State" },
        { type: "text", name: "City", key: "city", require: false, md: 6, placeholder: "Enter City" },
        { type: "number", name: "Ranking", key: "ranking", require: false, md: 6, placeholder: "e.g. 1" },
        { type: "number", name: "Established Year", key: "established", require: false, md: 6, placeholder: "e.g. 2000" },
        { type: "number", name: "Rating Score", key: "ratingScore", require: false, md: 6, placeholder: "e.g. 4.5" },
        { type: "multi-select", name: "Accreditations", key: "accreditations", require: false, md: 12, options: accreditationOptions },
        { type: "fileUpload", name: "Logo", key: "logo", require: false, md: 6 },
        { type: "fileUpload", name: "Background Image", key: "backgroundImg", require: false, md: 6 }
    ];

    const [activeRankingTab, setActiveRankingTab] = useState<string>("NIRF");
    const [newTabName, setNewTabName] = useState<string>("");
    const [showAddTabInput, setShowAddTabInput] = useState<boolean>(false);

    const [data, setData] = useState<any>({
        about: {
            title: '',
            paragraphs: ['']
        },
        rankings: {
            title: '',
            tabs: ['NIRF', 'Outlook'],
            tabData: {
                NIRF: [{ stream: 'Overall', years: { '2023': { rank: '', badge: '' } } }],
                Outlook: [{ stream: 'Overall', years: { '2023': { rank: '', badge: '' } } }]
            }
        },
        sampleDegree: {
            title: '',
            description: '',
            image: ''
        },
        whyChoose: [
            { num: "01", title: '', desc: '' }
        ],
        locationInfo: {
            address: '',
            campusArea: '',
            connectivity: '',
            latitude: 30.5162,
            longitude: 76.6592
        },
        toolsCertifications: [
            { num: "01", title: '', desc: '', featured: true }
        ],
        placementAssistance: {
            highestPackage: '',
            averagePackage: '',
            hiringPartners: '',
            partners: []
        },
        eligibility: {
            title: 'Who can Apply for Chitkara University Online?',
            items: [
                { icon: 'mortarboard', label: 'Educational qualification', text: '' },
                { icon: 'percent', label: 'Grades', text: '' },
                { icon: 'briefcase', label: 'Work experience', text: '' }
            ]
        },
        admissionProcess: [
            { step: '01', title: '', desc: '' }
        ],
        faqs: [
            { q: '', a: '' }
        ],
        established: '',
        ratingScore: 4.5
    });
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (id) {
            fetch(id);
        }
    }, [id]);

    const fetch = (id: any) => {
        setLoading(true);
        Api.get(`${url}/${id}`).then((res: any) => {
            let d = res?.data?.data || res?.data || res;
            if (d.universityPrograms && Array.isArray(d.universityPrograms)) {
                d.universityPrograms = d.universityPrograms.map((up: any) => ({
                    program: up.program?.id || up.program,
                    prize: up.prize || "",
                    description: up.description || ""
                }));
            }
            if (d.accreditations) {
                d.accreditations = d.accreditations.split(',').map((s: string) => s.trim());
            } else {
                d.accreditations = [];
            }
            if (typeof d.about === 'string') {
                try {
                    d.about = JSON.parse(d.about);
                } catch {
                    d.about = { title: '', paragraphs: d.about ? [d.about] : [''] };
                }
            }
            if (!d.about || typeof d.about !== 'object') {
                d.about = { title: '', paragraphs: [''] };
            }
            if (!Array.isArray(d.about.paragraphs)) {
                d.about.paragraphs = d.about.paragraphs ? [String(d.about.paragraphs)] : [''];
            }
            if (d.about.paragraphs.length === 0) {
                d.about.paragraphs = [''];
            }

            if (typeof d.rankings === 'string') {
                try {
                    d.rankings = JSON.parse(d.rankings);
                } catch {
                    d.rankings = null;
                }
            }
            if (!d.rankings || typeof d.rankings !== 'object') {
                d.rankings = {
                    title: '',
                    tabs: ['NIRF', 'Outlook'],
                    tabData: {
                        NIRF: [{ stream: 'Overall', years: { '2023': { rank: '', badge: '' } } }],
                        Outlook: [{ stream: 'Overall', years: { '2023': { rank: '', badge: '' } } }]
                    }
                };
            }
            const tabs = Array.isArray(d.rankings.tabs) && d.rankings.tabs.length > 0 ? d.rankings.tabs : ['NIRF', 'Outlook'];
            d.rankings.tabs = tabs;

            let tabData: any = d.rankings.tabData || {};
            if (!tabData['NIRF'] && d.rankings.nirfData) {
                tabData['NIRF'] = d.rankings.nirfData;
            }
            if (!tabData['Outlook'] && d.rankings.outlookData) {
                tabData['Outlook'] = d.rankings.outlookData;
            }

            tabs.forEach((tab: string) => {
                let streams = tabData[tab] || [];
                if (!Array.isArray(streams) || streams.length === 0) {
                    streams = [{ stream: 'Overall', years: { '2023': { rank: '', badge: '' } } }];
                } else {
                    streams = streams.map((row: any) => {
                        let years = row.years || {};
                        if (row.r2023 || row.r2022 || row.r2021) {
                            years = { ...years };
                            if (row.r2023) years['2023'] = { rank: row.r2023, badge: row.badge2023 || '' };
                            if (row.r2022) years['2022'] = { rank: row.r2022, badge: row.badge2022 || '' };
                            if (row.r2021) years['2021'] = { rank: row.r2021, badge: row.badge2021 || '' };
                        }
                        if (Object.keys(years).length === 0) {
                            years = { '2023': { rank: '', badge: '' } };
                        }
                        return { stream: row.stream || '', years };
                    });
                }
                tabData[tab] = streams;
            });
            d.rankings.tabData = tabData;

            if (typeof d.sampleDegree === 'string') {
                try {
                    d.sampleDegree = JSON.parse(d.sampleDegree);
                } catch {
                    d.sampleDegree = { title: '', description: '', image: '' };
                }
            }
            if (!d.sampleDegree || typeof d.sampleDegree !== 'object') {
                d.sampleDegree = { title: '', description: '', image: '' };
            }

            if (typeof d.whyChoose === 'string') {
                try {
                    d.whyChoose = JSON.parse(d.whyChoose);
                } catch {
                    d.whyChoose = [];
                }
            }
            if (!Array.isArray(d.whyChoose) || d.whyChoose.length === 0) {
                d.whyChoose = [{ num: "01", title: '', desc: '' }];
            } else {
                d.whyChoose = d.whyChoose.map((item: any, idx: number) => ({
                    num: String(idx + 1).padStart(2, '0'),
                    title: item.title || '',
                    desc: item.desc || ''
                }));
            }

            if (typeof d.locationInfo === 'string') {
                try {
                    d.locationInfo = JSON.parse(d.locationInfo);
                } catch {
                    d.locationInfo = { address: d.locationInfo || '' };
                }
            }
            if (!d.locationInfo || typeof d.locationInfo !== 'object') {
                d.locationInfo = {
                    address: '',
                    campusArea: '',
                    connectivity: '',
                    latitude: 30.5162,
                    longitude: 76.6592
                };
            }

            if (typeof d.toolsCertifications === 'string') {
                try {
                    d.toolsCertifications = JSON.parse(d.toolsCertifications);
                } catch {
                    d.toolsCertifications = [];
                }
            }
            if (!Array.isArray(d.toolsCertifications) || d.toolsCertifications.length === 0) {
                d.toolsCertifications = [
                    { num: "01", title: '', desc: '', featured: true }
                ];
            } else {
                d.toolsCertifications = d.toolsCertifications.map((item: any, idx: number) => ({
                    num: String(idx + 1).padStart(2, '0'),
                    title: item.title || '',
                    desc: item.desc || '',
                    featured: Boolean(item.featured)
                }));
            }
            if (typeof d.placementAssistance === 'string') {
                try {
                    d.placementAssistance = JSON.parse(d.placementAssistance);
                } catch {
                    d.placementAssistance = null;
                }
            }
            if (!d.placementAssistance || typeof d.placementAssistance !== 'object') {
                d.placementAssistance = {
                    highestPackage: '',
                    averagePackage: '',
                    hiringPartners: '',
                    partners: []
                };
            }
            if (!Array.isArray(d.placementAssistance.partners)) {
                d.placementAssistance.partners = typeof d.placementAssistance.partners === 'string'
                    ? d.placementAssistance.partners.split(',').map((p: string) => p.trim())
                    : [];
            }

            // Eligibility
            if (typeof d.eligibility === 'string') {
                try {
                    d.eligibility = JSON.parse(d.eligibility);
                } catch {
                    d.eligibility = null;
                }
            }
            if (!d.eligibility || typeof d.eligibility !== 'object') {
                d.eligibility = {
                    title: '',
                    items: [
                        { icon: 'mortarboard', label: 'Educational qualification', text: '' },
                        { icon: 'percent', label: 'Grades', text: '' },
                        { icon: 'briefcase', label: 'Work experience', text: '' }
                    ]
                };
            }
            if (!Array.isArray(d.eligibility.items)) {
                d.eligibility.items = [];
            }

            // Admission Process
            if (typeof d.admissionProcess === 'string') {
                try {
                    d.admissionProcess = JSON.parse(d.admissionProcess);
                } catch {
                    d.admissionProcess = [];
                }
            }
            if (!Array.isArray(d.admissionProcess) || d.admissionProcess.length === 0) {
                d.admissionProcess = [{ step: '01', title: '', desc: '' }];
            } else {
                d.admissionProcess = d.admissionProcess.map((item: any, idx: number) => ({
                    step: String(idx + 1).padStart(2, '0'),
                    title: item.title || '',
                    desc: item.desc || ''
                }));
            }

            // FAQs
            if (typeof d.faqs === 'string') {
                try {
                    d.faqs = JSON.parse(d.faqs);
                } catch {
                    d.faqs = [];
                }
            }
            if (!Array.isArray(d.faqs) || d.faqs.length === 0) {
                d.faqs = [{ q: '', a: '' }];
            } else {
                d.faqs = d.faqs.map((item: any) => ({
                    q: item.q || '',
                    a: item.a || ''
                }));
            }

            d.established = d.established ? Number(d.established) : '';
            d.ratingScore = d.ratingScore !== undefined && d.ratingScore !== null ? Number(d.ratingScore) : 4.5;

            setData(d);
        })
            .catch((e) => {
                alert(e?.message || e);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const Submit = async (e: React.FormEvent<HTMLInputElement> | any) => {
        e.preventDefault();

        // Prepare data for submission
        let submissionData = { ...data };
        if (Array.isArray(submissionData.accreditations)) {
            submissionData.accreditations = submissionData.accreditations.join(', ');
        }
        if (submissionData.about) {
            submissionData.about = {
                title: submissionData.about.title || '',
                paragraphs: Array.isArray(submissionData.about.paragraphs)
                    ? submissionData.about.paragraphs.filter((p: string) => p && p.trim().length > 0)
                    : []
            };
        }
        if (submissionData.rankings) {
            const tabs = submissionData.rankings.tabs || ['NIRF', 'Outlook'];
            const tabData = submissionData.rankings.tabData || {};
            const cleanTabData: any = {};
            tabs.forEach((tab: string) => {
                cleanTabData[tab] = (tabData[tab] || []).filter((item: any) => item.stream && item.stream.trim().length > 0);
            });

            submissionData.rankings = {
                title: submissionData.rankings.title || '',
                tabs: tabs,
                tabData: cleanTabData
            };
        }
        if (submissionData.sampleDegree) {
            submissionData.sampleDegree = {
                title: submissionData.sampleDegree.title || '',
                description: submissionData.sampleDegree.description || '',
                image: submissionData.sampleDegree.image || ''
            };
        }
        if (submissionData.whyChoose && Array.isArray(submissionData.whyChoose)) {
            submissionData.whyChoose = submissionData.whyChoose
                .filter((item: any) => item.title && item.title.trim().length > 0)
                .map((item: any, idx: number) => ({
                    num: String(idx + 1).padStart(2, '0'),
                    title: item.title,
                    desc: item.desc || ''
                }));
        }
        if (submissionData.locationInfo) {
            submissionData.locationInfo = {
                address: submissionData.locationInfo.address || '',
                campusArea: submissionData.locationInfo.campusArea || '',
                connectivity: submissionData.locationInfo.connectivity || '',
                latitude: submissionData.locationInfo.latitude,
                longitude: submissionData.locationInfo.longitude
            };
        }
        if (submissionData.toolsCertifications && Array.isArray(submissionData.toolsCertifications)) {
            submissionData.toolsCertifications = submissionData.toolsCertifications
                .filter((item: any) => item.title && item.title.trim().length > 0)
                .map((item: any, idx: number) => ({
                    num: String(idx + 1).padStart(2, '0'),
                    title: item.title,
                    desc: item.desc || '',
                    featured: Boolean(item.featured)
                }));
        }
        if (submissionData.placementAssistance) {
            submissionData.placementAssistance = {
                highestPackage: submissionData.placementAssistance.highestPackage || '',
                averagePackage: submissionData.placementAssistance.averagePackage || '',
                hiringPartners: submissionData.placementAssistance.hiringPartners || '',
                partners: Array.isArray(submissionData.placementAssistance.partners)
                    ? submissionData.placementAssistance.partners.filter((p: string) => p && p.trim().length > 0)
                    : []
            };
        }
        if (submissionData.eligibility) {
            submissionData.eligibility = {
                title: submissionData.eligibility.title || '',
                items: Array.isArray(submissionData.eligibility.items)
                    ? submissionData.eligibility.items.filter((item: any) => item.label && item.label.trim().length > 0)
                    : []
            };
        }
        if (submissionData.admissionProcess && Array.isArray(submissionData.admissionProcess)) {
            submissionData.admissionProcess = submissionData.admissionProcess
                .filter((item: any) => item.title && item.title.trim().length > 0)
                .map((item: any, idx: number) => ({
                    step: String(idx + 1).padStart(2, '0'),
                    title: item.title,
                    desc: item.desc || ''
                }));
        }
        if (submissionData.faqs && Array.isArray(submissionData.faqs)) {
            submissionData.faqs = submissionData.faqs
                .filter((item: any) => item.q && item.q.trim().length > 0)
                .map((item: any) => ({
                    q: item.q,
                    a: item.a || ''
                }));
        }
        if (submissionData.established !== undefined && submissionData.established !== '') {
            submissionData.established = Number(submissionData.established);
        } else {
            submissionData.established = null;
        }
        if (submissionData.ratingScore !== undefined && submissionData.ratingScore !== '') {
            submissionData.ratingScore = Number(submissionData.ratingScore);
        } else {
            submissionData.ratingScore = 4.5;
        }
        delete submissionData.location;
        delete submissionData.specializations;

        if (id) {
            Update(submissionData);
        }
        else {
            Create(submissionData);
        }
    };

    const Update = (submissionData: any) => {
        setLoading(true);
        Api.put(`${url}/${id}`, submissionData).then((res: any) => {
            navigate(`/UniversityList`);
        })
            .catch((e) => {
                alert(e?.message || e);
            }).finally(() => {
                setLoading(false);
            });
    }

    const Create = (submissionData: any) => {
        setLoading(true);
        Api.post(url, submissionData).then((res: any) => {
            navigate(`/UniversityList`);
        })
            .catch((e) => {
                alert(e?.message || e);
            }).finally(() => {
                setLoading(false);
            });
    }

    const onChange = (key: string, value: any) => {
        let d = { ...data };
        d[key] = value;

        if (key === 'name' && value) {
            d['slug'] = value.toString().toLowerCase()
                .replace(/\s+/g, '-')           // Replace spaces with -
                .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
                .replace(/\-\-+/g, '-')         // Replace multiple - with single -
                .replace(/^-+/, '')             // Trim - from start of text
                .replace(/-+$/, '');            // Trim - from end of text
        }

        setData(d);
    };

    return (
        <Container>
            {loading && <LoadingSpinner overlay text="Saving University..." />}
            <PageHeader
                title={id ? 'Edit University' : 'Add New University'}
                subtitle="Manage university profiles"
            />
            <Form onSubmit={Submit}>
                <Row>
                    {GenericForm(config, onChange, data)}

                    <Col md={12} className="mb-4">
                        <Form.Label className="generic-form-label mt-3">About University</Form.Label>
                        <div className="p-3 border rounded bg-white shadow-sm">
                            <Form.Group className="mb-3">
                                <Form.Label className="generic-form-label">
                                    About Title <span className="label-required">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="e.g. Get a Prestigious Degree at Chitkara University Online"
                                    value={data?.about?.title || ''}
                                    onChange={(e) => {
                                        const currentAbout = data?.about || { title: '', paragraphs: [''] };
                                        onChange('about', { ...currentAbout, title: e.target.value });
                                    }}
                                    className="generic-form-control"
                                    required
                                />
                            </Form.Group>

                            <Form.Label className="generic-form-label">
                                About Paragraphs <span className="label-required">*</span>
                            </Form.Label>
                            {(data?.about?.paragraphs && data.about.paragraphs.length > 0 ? data.about.paragraphs : ['']).map((paragraph: string, index: number) => (
                                <Row key={index} className="mb-2 align-items-start">
                                    <Col md={10}>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            placeholder={`Paragraph ${index + 1}`}
                                            value={paragraph || ''}
                                            onChange={(e) => {
                                                const currentParagraphs = [...(data?.about?.paragraphs && data.about.paragraphs.length > 0 ? data.about.paragraphs : [''])];
                                                currentParagraphs[index] = e.target.value;
                                                const currentAbout = data?.about || { title: '', paragraphs: [] };
                                                onChange('about', { ...currentAbout, paragraphs: currentParagraphs });
                                            }}
                                            className="generic-form-control"
                                            required={index === 0}
                                        />
                                    </Col>
                                    <Col md={2}>
                                        <Button
                                            variant="danger"
                                            size="sm"
                                            onClick={() => {
                                                const currentParagraphs = [...(data?.about?.paragraphs && data.about.paragraphs.length > 0 ? data.about.paragraphs : [''])];
                                                if (currentParagraphs.length > 1) {
                                                    currentParagraphs.splice(index, 1);
                                                } else {
                                                    currentParagraphs[0] = '';
                                                }
                                                const currentAbout = data?.about || { title: '', paragraphs: [] };
                                                onChange('about', { ...currentAbout, paragraphs: currentParagraphs });
                                            }}
                                        >
                                            Remove
                                        </Button>
                                    </Col>
                                </Row>
                            ))}
                            <div className="mt-2">
                                <Button
                                    variant="secondary"
                                    size="sm"
                                    onClick={() => {
                                        const currentParagraphs = [...(data?.about?.paragraphs && data.about.paragraphs.length > 0 ? data.about.paragraphs : [''])];
                                        currentParagraphs.push('');
                                        const currentAbout = data?.about || { title: '', paragraphs: [] };
                                        onChange('about', { ...currentAbout, paragraphs: currentParagraphs });
                                    }}
                                >
                                    + Add Paragraph
                                </Button>
                            </div>
                        </div>
                    </Col>

                    <Col md={12} className="mb-4">
                        <Form.Label className="generic-form-label mt-3">Rankings & Recognition</Form.Label>
                        <div className="p-3 border rounded bg-white shadow-sm">
                            <Form.Group className="mb-3">
                                <Form.Label className="generic-form-label">Rankings Title</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="e.g. Chitkara University Online rankings & recognition"
                                    value={data?.rankings?.title || ''}
                                    onChange={(e) => {
                                        const curRankings = data?.rankings || {};
                                        onChange('rankings', { ...curRankings, title: e.target.value });
                                    }}
                                    className="generic-form-control"
                                />
                            </Form.Group>

                            {/* TABS SELECTOR */}
                            <div className="mb-3">
                                <Form.Label className="generic-form-label">Rankings Tabs</Form.Label>
                                <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
                                    {(data?.rankings?.tabs || ['NIRF', 'Outlook']).map((tab: string) => {
                                        const isActive = (activeRankingTab || 'NIRF') === tab;
                                        return (
                                            <div key={tab} className="btn-group" role="group">
                                                <Button
                                                    variant={isActive ? "primary" : "outline-primary"}
                                                    size="sm"
                                                    onClick={() => setActiveRankingTab(tab)}
                                                >
                                                    {tab}
                                                </Button>
                                                {(data?.rankings?.tabs || []).length > 1 && (
                                                    <Button
                                                        variant={isActive ? "danger" : "outline-danger"}
                                                        size="sm"
                                                        title={`Delete ${tab} tab`}
                                                        onClick={() => {
                                                            const newTabs = (data?.rankings?.tabs || []).filter((t: string) => t !== tab);
                                                            const curTabData = { ...(data?.rankings?.tabData || {}) };
                                                            delete curTabData[tab];
                                                            const nextActive = newTabs[0] || 'NIRF';
                                                            setActiveRankingTab(nextActive);
                                                            onChange('rankings', {
                                                                ...(data?.rankings || {}),
                                                                tabs: newTabs,
                                                                tabData: curTabData
                                                            });
                                                        }}
                                                    >
                                                        ×
                                                    </Button>
                                                )}
                                            </div>
                                        );
                                    })}

                                    {showAddTabInput ? (
                                        <div className="d-flex align-items-center gap-1">
                                            <Form.Control
                                                type="text"
                                                size="sm"
                                                placeholder="Tab name (e.g. Outlook)"
                                                value={newTabName}
                                                onChange={(e) => setNewTabName(e.target.value)}
                                                style={{ width: "150px" }}
                                            />
                                            <Button
                                                variant="success"
                                                size="sm"
                                                onClick={() => {
                                                    const trimmed = newTabName.trim();
                                                    if (trimmed && !(data?.rankings?.tabs || []).includes(trimmed)) {
                                                        const newTabs = [...(data?.rankings?.tabs || []), trimmed];
                                                        const curTabData = { ...(data?.rankings?.tabData || {}) };
                                                        if (!curTabData[trimmed]) {
                                                            curTabData[trimmed] = [{ stream: 'Overall', years: { [new Date().getFullYear().toString()]: { rank: '', badge: '' } } }];
                                                        }
                                                        setActiveRankingTab(trimmed);
                                                        setNewTabName('');
                                                        setShowAddTabInput(false);
                                                        onChange('rankings', {
                                                            ...(data?.rankings || {}),
                                                            tabs: newTabs,
                                                            tabData: curTabData
                                                        });
                                                    }
                                                }}
                                            >
                                                Add
                                            </Button>
                                            <Button
                                                variant="secondary"
                                                size="sm"
                                                onClick={() => {
                                                    setShowAddTabInput(false);
                                                    setNewTabName('');
                                                }}
                                            >
                                                Cancel
                                            </Button>
                                        </div>
                                    ) : (
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            onClick={() => setShowAddTabInput(true)}
                                        >
                                            + Add New Tab
                                        </Button>
                                    )}
                                </div>
                            </div>

                            {/* ACTIVE TAB STREAMS */}
                            {(() => {
                                const currentTab = activeRankingTab || (data?.rankings?.tabs?.[0]) || 'NIRF';
                                const currentStreams = data?.rankings?.tabData?.[currentTab] || [];

                                return (
                                    <div className="p-3 border rounded bg-white">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <h6 className="mb-0 fw-bold text-primary">{currentTab} Ranking Streams</h6>
                                            <span className="badge bg-secondary">{currentStreams.length} stream(s)</span>
                                        </div>

                                        {currentStreams.map((row: any, rIdx: number) => (
                                            <div key={rIdx} className="p-3 mb-3 border rounded bg-light">
                                                <Row className="mb-3 align-items-center">
                                                    <Col md={10}>
                                                        <Form.Label className="small fw-bold">Stream Name</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="e.g. Overall / MBA / B.Tech"
                                                            value={row.stream || ''}
                                                            onChange={(e) => {
                                                                const curTabData = { ...(data?.rankings?.tabData || {}) };
                                                                const newStreams = [...(curTabData[currentTab] || [])];
                                                                newStreams[rIdx] = { ...newStreams[rIdx], stream: e.target.value };
                                                                curTabData[currentTab] = newStreams;
                                                                onChange('rankings', { ...(data?.rankings || {}), tabData: curTabData });
                                                            }}
                                                            className="generic-form-control"
                                                        />
                                                    </Col>
                                                    <Col md={2} className="d-flex align-items-end mt-4">
                                                        <Button
                                                            variant="danger"
                                                            size="sm"
                                                            onClick={() => {
                                                                const curTabData = { ...(data?.rankings?.tabData || {}) };
                                                                const newStreams = [...(curTabData[currentTab] || [])];
                                                                newStreams.splice(rIdx, 1);
                                                                curTabData[currentTab] = newStreams;
                                                                onChange('rankings', { ...(data?.rankings || {}), tabData: curTabData });
                                                            }}
                                                        >
                                                            Remove Stream
                                                        </Button>
                                                    </Col>
                                                </Row>

                                                <div className="ps-3 border-start border-3 border-primary">
                                                    <Form.Label className="small fw-bold text-muted">Yearly Rankings (e.g. 2024, 2023, 2022)</Form.Label>
                                                    {((row._yearsList) || (
                                                        Object.entries(row.years || {}).map(([yearKey, val]: [string, any]) => ({
                                                            year: yearKey,
                                                            rank: val?.rank || '',
                                                            badge: val?.badge || ''
                                                        }))
                                                    )).map((item: any, yIdx: number, listArr: any[]) => (
                                                        <Row key={yIdx} className="mb-2 align-items-center">
                                                            <Col md={3}>
                                                                <Form.Label className="small">Year</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Year (e.g. 2024)"
                                                                    value={item.year}
                                                                    onChange={(e) => {
                                                                        const newYear = e.target.value;
                                                                        const curTabData = { ...(data?.rankings?.tabData || {}) };
                                                                        const newStreams = [...(curTabData[currentTab] || [])];
                                                                        const nextList = listArr.map((it, idx) => idx === yIdx ? { ...it, year: newYear } : it);

                                                                        const newYears: any = {};
                                                                        nextList.forEach((it) => {
                                                                            newYears[it.year] = { rank: it.rank, badge: it.badge };
                                                                        });

                                                                        newStreams[rIdx] = { ...newStreams[rIdx], years: newYears, _yearsList: nextList };
                                                                        curTabData[currentTab] = newStreams;
                                                                        onChange('rankings', { ...(data?.rankings || {}), tabData: curTabData });
                                                                    }}
                                                                    className="generic-form-control"
                                                                />
                                                            </Col>
                                                            <Col md={4}>
                                                                <Form.Label className="small">Rank</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Rank (e.g. #101 out of 200 in India)"
                                                                    value={item.rank || ''}
                                                                    onChange={(e) => {
                                                                        const nextRank = e.target.value;
                                                                        const curTabData = { ...(data?.rankings?.tabData || {}) };
                                                                        const newStreams = [...(curTabData[currentTab] || [])];
                                                                        const nextList = listArr.map((it, idx) => idx === yIdx ? { ...it, rank: nextRank } : it);

                                                                        const newYears: any = {};
                                                                        nextList.forEach((it) => {
                                                                            newYears[it.year] = { rank: it.rank, badge: it.badge };
                                                                        });

                                                                        newStreams[rIdx] = { ...newStreams[rIdx], years: newYears, _yearsList: nextList };
                                                                        curTabData[currentTab] = newStreams;
                                                                        onChange('rankings', { ...(data?.rankings || {}), tabData: curTabData });
                                                                    }}
                                                                    className="generic-form-control"
                                                                />
                                                            </Col>
                                                            <Col md={3}>
                                                                <Form.Label className="small">Badge</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Badge (e.g. #9th in Punjab)"
                                                                    value={item.badge || ''}
                                                                    onChange={(e) => {
                                                                        const nextBadge = e.target.value;
                                                                        const curTabData = { ...(data?.rankings?.tabData || {}) };
                                                                        const newStreams = [...(curTabData[currentTab] || [])];
                                                                        const nextList = listArr.map((it, idx) => idx === yIdx ? { ...it, badge: nextBadge } : it);

                                                                        const newYears: any = {};
                                                                        nextList.forEach((it) => {
                                                                            newYears[it.year] = { rank: it.rank, badge: it.badge };
                                                                        });

                                                                        newStreams[rIdx] = { ...newStreams[rIdx], years: newYears, _yearsList: nextList };
                                                                        curTabData[currentTab] = newStreams;
                                                                        onChange('rankings', { ...(data?.rankings || {}), tabData: curTabData });
                                                                    }}
                                                                    className="generic-form-control"
                                                                />
                                                            </Col>
                                                            <Col md={2} className="d-flex align-items-end mt-4">
                                                                <Button
                                                                    variant="outline-danger"
                                                                    size="sm"
                                                                    onClick={() => {
                                                                        const curTabData = { ...(data?.rankings?.tabData || {}) };
                                                                        const newStreams = [...(curTabData[currentTab] || [])];
                                                                        const nextList = listArr.filter((_, idx) => idx !== yIdx);

                                                                        const newYears: any = {};
                                                                        nextList.forEach((it) => {
                                                                            newYears[it.year] = { rank: it.rank, badge: it.badge };
                                                                        });

                                                                        newStreams[rIdx] = { ...newStreams[rIdx], years: newYears, _yearsList: nextList };
                                                                        curTabData[currentTab] = newStreams;
                                                                        onChange('rankings', { ...(data?.rankings || {}), tabData: curTabData });
                                                                    }}
                                                                >
                                                                    Remove Year
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    ))}
                                                    <div className="mt-2">
                                                        <Button
                                                            variant="outline-secondary"
                                                            size="sm"
                                                            onClick={() => {
                                                                const curTabData = { ...(data?.rankings?.tabData || {}) };
                                                                const newStreams = [...(curTabData[currentTab] || [])];
                                                                const currentList = row._yearsList || Object.entries(row.years || {}).map(([y, v]: [string, any]) => ({
                                                                    year: y,
                                                                    rank: v?.rank || '',
                                                                    badge: v?.badge || ''
                                                                }));
                                                                const nextYear = String(new Date().getFullYear() - currentList.length);
                                                                const nextList = [...currentList, { year: nextYear, rank: '', badge: '' }];

                                                                const newYears: any = {};
                                                                nextList.forEach((it) => {
                                                                    newYears[it.year] = { rank: it.rank, badge: it.badge };
                                                                });

                                                                newStreams[rIdx] = { ...newStreams[rIdx], years: newYears, _yearsList: nextList };
                                                                curTabData[currentTab] = newStreams;
                                                                onChange('rankings', { ...(data?.rankings || {}), tabData: curTabData });
                                                            }}
                                                        >
                                                            + Add Year
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}

                                        <div className="mt-2">
                                            <Button
                                                variant="secondary"
                                                size="sm"
                                                onClick={() => {
                                                    const curTabData = { ...(data?.rankings?.tabData || {}) };
                                                    const newStreams = [...(curTabData[currentTab] || [])];
                                                    newStreams.push({ stream: '', years: { [new Date().getFullYear().toString()]: { rank: '', badge: '' } } });
                                                    curTabData[currentTab] = newStreams;
                                                    onChange('rankings', { ...(data?.rankings || {}), tabData: curTabData });
                                                }}
                                            >
                                                + Add Stream Ranking to {currentTab}
                                            </Button>
                                        </div>
                                    </div>
                                );
                            })()}
                        </div>
                    </Col>

                    <Col md={12} className="mb-4">
                        <Form.Label className="generic-form-label mt-3">Sample Degree</Form.Label>
                        <div className="p-3 border rounded bg-white shadow-sm">
                            <Form.Group className="mb-3">
                                <Form.Label className="generic-form-label">Degree Section Title</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="e.g. Get a Prestigious Degree at Chitkara University Online"
                                    value={data?.sampleDegree?.title || ''}
                                    onChange={(e) => {
                                        const cur = data?.sampleDegree || {};
                                        onChange('sampleDegree', { ...cur, title: e.target.value });
                                    }}
                                    className="generic-form-control"
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="generic-form-label">Degree Description</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    placeholder="Describe the degree, recognized curriculum, practical expertise..."
                                    value={data?.sampleDegree?.description || ''}
                                    onChange={(e) => {
                                        const cur = data?.sampleDegree || {};
                                        onChange('sampleDegree', { ...cur, description: e.target.value });
                                    }}
                                    className="generic-form-control"
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="generic-form-label">Sample Degree Image</Form.Label>
                                <FileUpload
                                    onChange={(_key: any, val: any) => {
                                        const cur = data?.sampleDegree || {};
                                        onChange('sampleDegree', { ...cur, image: val });
                                    }}
                                    fieldKey="sampleDegreeImage"
                                    value={data?.sampleDegree?.image}
                                />
                            </Form.Group>
                        </div>
                    </Col>

                    {/* Why Choose Section */}
                    <Col md={12} className="mb-4">
                        <div className="section-container border p-3 rounded bg-white shadow-sm">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                    <h5 className="mb-0 font-weight-bold" style={{ color: '#2B3674' }}>Why Choose Section</h5>
                                    <small className="text-muted">Highlight reasons to choose this university (numbers are auto-generated)</small>
                                </div>
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={() => {
                                        const cur = data?.whyChoose || [];
                                        const nextNum = String(cur.length + 1).padStart(2, '0');
                                        onChange('whyChoose', [...cur, { num: nextNum, title: '', desc: '' }]);
                                    }}
                                >
                                    + Add Reason
                                </Button>
                            </div>

                            {(data?.whyChoose || []).map((item: any, index: number) => {
                                const displayNum = String(index + 1).padStart(2, '0');
                                return (
                                    <div key={index} className="p-3 mb-3 border rounded bg-light">
                                        <Row className="align-items-start">
                                            <Col md={1} className="d-flex align-items-center justify-content-center pt-2">
                                                <span
                                                    className="badge bg-primary fs-6 px-3 py-2"
                                                    style={{ borderRadius: '8px', minWidth: '45px', textAlign: 'center' }}
                                                >
                                                    {displayNum}
                                                </span>
                                            </Col>
                                            <Col md={10}>
                                                <Row>
                                                    <Col md={12} className="mb-2">
                                                        <Form.Label className="small text-muted mb-1">Title</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="e.g. Diverse Learning Mediums"
                                                            value={item.title || ''}
                                                            onChange={(e) => {
                                                                const newWhy = [...(data?.whyChoose || [])];
                                                                newWhy[index].title = e.target.value;
                                                                newWhy[index].num = displayNum;
                                                                onChange('whyChoose', newWhy);
                                                            }}
                                                            className="generic-form-control"
                                                        />
                                                    </Col>
                                                    <Col md={12}>
                                                        <Form.Label className="small text-muted mb-1">Description</Form.Label>
                                                        <Form.Control
                                                            as="textarea"
                                                            rows={2}
                                                            placeholder="e.g. E-books, printed & audio books, videos to cater your preferences & unique learning style."
                                                            value={item.desc || ''}
                                                            onChange={(e) => {
                                                                const newWhy = [...(data?.whyChoose || [])];
                                                                newWhy[index].desc = e.target.value;
                                                                newWhy[index].num = displayNum;
                                                                onChange('whyChoose', newWhy);
                                                            }}
                                                            className="generic-form-control"
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col md={1} className="d-flex align-items-center justify-content-end pt-2">
                                                <Button
                                                    variant="danger"
                                                    size="sm"
                                                    disabled={(data?.whyChoose || []).length <= 1}
                                                    onClick={() => {
                                                        const newWhy = [...(data?.whyChoose || [])];
                                                        newWhy.splice(index, 1);
                                                        const reindexed = newWhy.map((it: any, idx: number) => ({
                                                            ...it,
                                                            num: String(idx + 1).padStart(2, '0')
                                                        }));
                                                        onChange('whyChoose', reindexed);
                                                    }}
                                                >
                                                    Remove
                                                </Button>
                                            </Col>
                                        </Row>
                                    </div>
                                );
                            })}
                        </div>
                    </Col>

                    {/* Tools & Certifications Section */}
                    <Col md={12} className="mb-4">
                        <div className="section-container border p-3 rounded bg-white shadow-sm">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                    <h5 className="mb-0 font-weight-bold" style={{ color: '#2B3674' }}>Tools and Certifications</h5>
                                    <small className="text-muted">Certifications, industry partnerships, and learning tools (e.g. LinkedIn Learning, Coursera)</small>
                                </div>
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={() => {
                                        const cur = data?.toolsCertifications || [];
                                        const nextNum = String(cur.length + 1).padStart(2, '0');
                                        onChange('toolsCertifications', [...cur, { num: nextNum, title: '', desc: '', featured: false }]);
                                    }}
                                >
                                    + Add Tool / Certification
                                </Button>
                            </div>

                            {(data?.toolsCertifications || []).map((item: any, index: number) => {
                                const displayNum = String(index + 1).padStart(2, '0');
                                return (
                                    <div key={index} className={`p-3 mb-3 border rounded ${item.featured ? 'border-primary bg-light' : 'bg-white'}`}>
                                        <Row className="align-items-start">
                                            <Col md={1} className="d-flex align-items-center justify-content-center pt-2">
                                                <span
                                                    className={`badge ${item.featured ? 'bg-primary' : 'bg-secondary'} fs-6 px-3 py-2`}
                                                    style={{ borderRadius: '8px', minWidth: '45px', textAlign: 'center' }}
                                                >
                                                    {displayNum}
                                                </span>
                                            </Col>
                                            <Col md={10}>
                                                <Row>
                                                    <Col md={8} className="mb-2">
                                                        <Form.Label className="small text-muted mb-1">Title</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="e.g. LinkedIn Learning, Coursera, DeakinCo. Certification"
                                                            value={item.title || ''}
                                                            onChange={(e) => {
                                                                const newTools = [...(data?.toolsCertifications || [])];
                                                                newTools[index].title = e.target.value;
                                                                newTools[index].num = displayNum;
                                                                onChange('toolsCertifications', newTools);
                                                            }}
                                                            className="generic-form-control"
                                                        />
                                                    </Col>
                                                    <Col md={4} className="mb-2 d-flex align-items-center pt-3">
                                                        <Form.Check
                                                            type="switch"
                                                            id={`featured-switch-${index}`}
                                                            label={<span className="small font-weight-bold">{item.featured ? '⭐ Featured Banner' : 'Standard Card'}</span>}
                                                            checked={Boolean(item.featured)}
                                                            onChange={(e) => {
                                                                const newTools = [...(data?.toolsCertifications || [])];
                                                                newTools[index].featured = e.target.checked;
                                                                onChange('toolsCertifications', newTools);
                                                            }}
                                                        />
                                                    </Col>
                                                    <Col md={12}>
                                                        <Form.Label className="small text-muted mb-1">Description</Form.Label>
                                                        <Form.Control
                                                            as="textarea"
                                                            rows={2}
                                                            placeholder="e.g. Access to over 16,000 expert-led courses, allowing students to develop job-relevant skills..."
                                                            value={item.desc || ''}
                                                            onChange={(e) => {
                                                                const newTools = [...(data?.toolsCertifications || [])];
                                                                newTools[index].desc = e.target.value;
                                                                newTools[index].num = displayNum;
                                                                onChange('toolsCertifications', newTools);
                                                            }}
                                                            className="generic-form-control"
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col md={1} className="d-flex align-items-center justify-content-end pt-2">
                                                <Button
                                                    variant="danger"
                                                    size="sm"
                                                    disabled={(data?.toolsCertifications || []).length <= 1}
                                                    onClick={() => {
                                                        const newTools = [...(data?.toolsCertifications || [])];
                                                        newTools.splice(index, 1);
                                                        const reindexed = newTools.map((it: any, idx: number) => ({
                                                            ...it,
                                                            num: String(idx + 1).padStart(2, '0')
                                                        }));
                                                        onChange('toolsCertifications', reindexed);
                                                    }}
                                                >
                                                    Remove
                                                </Button>
                                            </Col>
                                        </Row>
                                    </div>
                                );
                            })}
                        </div>
                    </Col>

                    {/* Placement Assistance Section */}
                    <Col md={12} className="mb-4">
                        <div className="section-container border p-3 rounded bg-white shadow-sm">
                            <h5 className="mb-1 font-weight-bold" style={{ color: '#2B3674' }}>Placement Assistance & Hiring Partners</h5>
                            <small className="text-muted d-block mb-3">Placement packages, hiring partners count, and key recruiters (e.g. Amazon, Microsoft)</small>

                            <Row className="gy-3">
                                <Col md={4}>
                                    <Form.Label className="small font-weight-bold text-muted mb-1">
                                        Highest Package
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="e.g. ₹18 LPA"
                                        value={data?.placementAssistance?.highestPackage || ''}
                                        onChange={(e) => {
                                            const cur = data?.placementAssistance || {};
                                            onChange('placementAssistance', { ...cur, highestPackage: e.target.value });
                                        }}
                                        className="generic-form-control"
                                    />
                                </Col>

                                <Col md={4}>
                                    <Form.Label className="small font-weight-bold text-muted mb-1">
                                        Average Package
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="e.g. ₹6.5 LPA"
                                        value={data?.placementAssistance?.averagePackage || ''}
                                        onChange={(e) => {
                                            const cur = data?.placementAssistance || {};
                                            onChange('placementAssistance', { ...cur, averagePackage: e.target.value });
                                        }}
                                        className="generic-form-control"
                                    />
                                </Col>

                                <Col md={4}>
                                    <Form.Label className="small font-weight-bold text-muted mb-1">
                                        Hiring Partners Count
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="e.g. 500+"
                                        value={data?.placementAssistance?.hiringPartners || ''}
                                        onChange={(e) => {
                                            const cur = data?.placementAssistance || {};
                                            onChange('placementAssistance', { ...cur, hiringPartners: e.target.value });
                                        }}
                                        className="generic-form-control"
                                    />
                                </Col>

                                <Col md={12}>
                                    <Form.Label className="small font-weight-bold text-muted mb-1">
                                        Top Hiring Partners (comma separated)
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="e.g. Amazon, Microsoft, Deloitte, KPMG, Wipro, Infosys, TCS, Accenture"
                                        value={Array.isArray(data?.placementAssistance?.partners) ? data.placementAssistance.partners.join(', ') : (data?.placementAssistance?.partners || '')}
                                        onChange={(e) => {
                                            const raw = e.target.value;
                                            const cur = data?.placementAssistance || {};
                                            const arr = raw.split(',').map((s: string) => s.trim());
                                            onChange('placementAssistance', { ...cur, partners: arr });
                                        }}
                                        className="generic-form-control"
                                    />
                                    <div className="d-flex flex-wrap gap-1 mt-2">
                                        {(data?.placementAssistance?.partners || []).filter((p: string) => p && p.length > 0).map((partner: string, pIdx: number) => (
                                            <span key={pIdx} className="badge bg-secondary me-1 mb-1 px-2 py-1">
                                                {partner}
                                            </span>
                                        ))}
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Col>

                    {/* Eligibility Section */}
                    <Col md={12} className="mb-4">
                        <div className="section-container border p-3 rounded bg-white shadow-sm">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                    <h5 className="mb-0 font-weight-bold" style={{ color: '#2B3674' }}>Eligibility (Who Can Apply)</h5>
                                    <small className="text-muted">Requirements and criteria for applicants</small>
                                </div>
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={() => {
                                        const cur = data?.eligibility?.items || [];
                                        const newItems = [...cur, { icon: 'mortarboard', label: '', text: '' }];
                                        onChange('eligibility', { ...(data?.eligibility || {}), items: newItems });
                                    }}
                                >
                                    + Add Criteria
                                </Button>
                            </div>

                            <Form.Group className="mb-3">
                                <Form.Label className="small font-weight-bold text-muted mb-1">Section Title</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="e.g. Who can Apply for Chitkara University Online?"
                                    value={data?.eligibility?.title || ''}
                                    onChange={(e) => {
                                        onChange('eligibility', { ...(data?.eligibility || {}), title: e.target.value });
                                    }}
                                    className="generic-form-control"
                                />
                            </Form.Group>

                            {(data?.eligibility?.items || []).map((item: any, index: number) => (
                                <div key={index} className="p-3 mb-3 border rounded bg-light">
                                    <Row className="align-items-start">
                                        <Col md={3}>
                                            <Form.Label className="small text-muted mb-1">Icon</Form.Label>
                                            <Form.Select
                                                value={item.icon || 'mortarboard'}
                                                onChange={(e) => {
                                                    const newItems = [...(data?.eligibility?.items || [])];
                                                    newItems[index].icon = e.target.value;
                                                    onChange('eligibility', { ...(data?.eligibility || {}), items: newItems });
                                                }}
                                                className="generic-form-control"
                                            >
                                                <option value="mortarboard">🎓 Education (mortarboard)</option>
                                                <option value="percent">% Grades / Percentage</option>
                                                <option value="briefcase">💼 Work Experience (briefcase)</option>
                                            </Form.Select>
                                        </Col>
                                        <Col md={8}>
                                            <Row>
                                                <Col md={12} className="mb-2">
                                                    <Form.Label className="small text-muted mb-1">Criteria Label</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="e.g. Educational qualification, Grades, Work experience"
                                                        value={item.label || ''}
                                                        onChange={(e) => {
                                                            const newItems = [...(data?.eligibility?.items || [])];
                                                            newItems[index].label = e.target.value;
                                                            onChange('eligibility', { ...(data?.eligibility || {}), items: newItems });
                                                        }}
                                                        className="generic-form-control"
                                                    />
                                                </Col>
                                                <Col md={12}>
                                                    <Form.Label className="small text-muted mb-1">Criteria Requirement Text</Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={2}
                                                        placeholder="e.g. Candidates must have a 10 + 2 + 3-year bachelor's degree..."
                                                        value={item.text || ''}
                                                        onChange={(e) => {
                                                            const newItems = [...(data?.eligibility?.items || [])];
                                                            newItems[index].text = e.target.value;
                                                            onChange('eligibility', { ...(data?.eligibility || {}), items: newItems });
                                                        }}
                                                        className="generic-form-control"
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md={1} className="d-flex align-items-center justify-content-end pt-3">
                                            <Button
                                                variant="danger"
                                                size="sm"
                                                disabled={(data?.eligibility?.items || []).length <= 1}
                                                onClick={() => {
                                                    const newItems = [...(data?.eligibility?.items || [])];
                                                    newItems.splice(index, 1);
                                                    onChange('eligibility', { ...(data?.eligibility || {}), items: newItems });
                                                }}
                                            >
                                                Remove
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>
                            ))}
                        </div>
                    </Col>

                    {/* Admission Process Section */}
                    <Col md={12} className="mb-4">
                        <div className="section-container border p-3 rounded bg-white shadow-sm">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                    <h5 className="mb-0 font-weight-bold" style={{ color: '#2B3674' }}>Admission Process</h5>
                                    <small className="text-muted">Step-by-step admission procedure (step numbers are auto-generated)</small>
                                </div>
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={() => {
                                        const cur = data?.admissionProcess || [];
                                        const nextStep = String(cur.length + 1).padStart(2, '0');
                                        onChange('admissionProcess', [...cur, { step: nextStep, title: '', desc: '' }]);
                                    }}
                                >
                                    + Add Step
                                </Button>
                            </div>

                            {(data?.admissionProcess || []).map((stepItem: any, index: number) => {
                                const displayStep = String(index + 1).padStart(2, '0');
                                return (
                                    <div key={index} className="p-3 mb-3 border rounded bg-light">
                                        <Row className="align-items-start">
                                            <Col md={1} className="d-flex align-items-center justify-content-center pt-2">
                                                <span
                                                    className="badge bg-primary fs-6 px-3 py-2"
                                                    style={{ borderRadius: '8px', minWidth: '45px', textAlign: 'center' }}
                                                >
                                                    {displayStep}
                                                </span>
                                            </Col>
                                            <Col md={10}>
                                                <Row>
                                                    <Col md={12} className="mb-2">
                                                        <Form.Label className="small text-muted mb-1">Step Title</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="e.g. Program Registration, Fee Payment, Document Submission"
                                                            value={stepItem.title || ''}
                                                            onChange={(e) => {
                                                                const newProcess = [...(data?.admissionProcess || [])];
                                                                newProcess[index].title = e.target.value;
                                                                newProcess[index].step = displayStep;
                                                                onChange('admissionProcess', newProcess);
                                                            }}
                                                            className="generic-form-control"
                                                        />
                                                    </Col>
                                                    <Col md={12}>
                                                        <Form.Label className="small text-muted mb-1">Step Description</Form.Label>
                                                        <Form.Control
                                                            as="textarea"
                                                            rows={2}
                                                            placeholder="e.g. Complete the registration by filling in your personal, educational details..."
                                                            value={stepItem.desc || ''}
                                                            onChange={(e) => {
                                                                const newProcess = [...(data?.admissionProcess || [])];
                                                                newProcess[index].desc = e.target.value;
                                                                newProcess[index].step = displayStep;
                                                                onChange('admissionProcess', newProcess);
                                                            }}
                                                            className="generic-form-control"
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col md={1} className="d-flex align-items-center justify-content-end pt-2">
                                                <Button
                                                    variant="danger"
                                                    size="sm"
                                                    disabled={(data?.admissionProcess || []).length <= 1}
                                                    onClick={() => {
                                                        const newProcess = [...(data?.admissionProcess || [])];
                                                        newProcess.splice(index, 1);
                                                        const reindexed = newProcess.map((it: any, idx: number) => ({
                                                            ...it,
                                                            step: String(idx + 1).padStart(2, '0')
                                                        }));
                                                        onChange('admissionProcess', reindexed);
                                                    }}
                                                >
                                                    Remove
                                                </Button>
                                            </Col>
                                        </Row>
                                    </div>
                                );
                            })}
                        </div>
                    </Col>

                    {/* Location Info & Map Picker Section */}
                    <Col md={12} className="mb-4">
                        <div className="section-container border p-3 rounded bg-white shadow-sm">
                            <h5 className="mb-1 font-weight-bold" style={{ color: '#2B3674' }}>Location & Campus Information</h5>
                            <small className="text-muted d-block mb-3">Search or click anywhere on the interactive map to automatically select address and coordinates</small>
                            <MapLocationPicker
                                value={data?.locationInfo}
                                onChange={(val) => onChange('locationInfo', val)}
                            />
                        </div>
                    </Col>

                    <Col md={12} className="mb-4">
                        <Form.Label className="generic-form-label mt-3">Programs & Prize</Form.Label>
                        {(data?.universityPrograms || []).map((up: any, index: number) => (
                            <div key={index} className="p-3 mb-3 border rounded bg-light">
                                <Row className="align-items-center">
                                    <Col md={5}>
                                        <Form.Label className="small text-muted mb-1">Program</Form.Label>
                                        <Form.Select
                                            value={up.program}
                                            onChange={(e) => {
                                                const newUP = [...(data.universityPrograms || [])];
                                                newUP[index].program = e.target.value;
                                                onChange('universityPrograms', newUP);
                                            }}
                                            className="generic-form-control"
                                        >
                                            <option value="">Select Program...</option>
                                            {programsList.map(p => (
                                                <option key={p.value} value={p.value}>{p.label}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                    <Col md={5}>
                                        <Form.Label className="small text-muted mb-1">Prize/Price</Form.Label>
                                        <Form.Control
                                            type="number"
                                            min={0}
                                            placeholder="e.g. 75000"
                                            value={up.prize ?? ''}
                                            onChange={(e) => {
                                                const newUP = [...(data.universityPrograms || [])];
                                                newUP[index].prize = e.target.value === '' ? null : Number(e.target.value);
                                                onChange('universityPrograms', newUP);
                                            }}
                                            className="generic-form-control"
                                        />
                                    </Col>
                                    <Col md={2} className="d-flex align-items-end mt-3">
                                        <Button variant="danger" size="sm" onClick={() => {
                                            const newUP = [...(data.universityPrograms || [])];
                                            newUP.splice(index, 1);
                                            onChange('universityPrograms', newUP);
                                        }}>Remove</Button>
                                    </Col>
                                </Row>
                                <Row className="mt-2">
                                    <Col md={12}>
                                        <Form.Label className="small text-muted mb-1">Program Description</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={2}
                                            placeholder="Program description..."
                                            value={up.description || ''}
                                            onChange={(e) => {
                                                const newUP = [...(data.universityPrograms || [])];
                                                newUP[index].description = e.target.value;
                                                onChange('universityPrograms', newUP);
                                            }}
                                            className="generic-form-control"
                                        />
                                    </Col>
                                </Row>
                            </div>
                        ))}
                        <div className="mt-2">
                            <Button variant="secondary" size="sm" onClick={() => {
                                const newUP = [...(data?.universityPrograms || [])];
                                newUP.push({ program: '', prize: null, description: '' });
                                onChange('universityPrograms', newUP);
                            }}>+ Add Program</Button>
                        </div>
                    </Col>

                    {/* FAQs Section */}
                    <Col md={12} className="mb-4">
                        <div className="section-container border p-3 rounded bg-white shadow-sm">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                    <h5 className="mb-0 font-weight-bold" style={{ color: '#2B3674' }}>Frequently Asked Questions (FAQs)</h5>
                                    <small className="text-muted">Common questions and detailed answers</small>
                                </div>
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={() => {
                                        const cur = data?.faqs || [];
                                        onChange('faqs', [...cur, { q: '', a: '' }]);
                                    }}
                                >
                                    + Add FAQ
                                </Button>
                            </div>

                            {(data?.faqs || []).map((faq: any, index: number) => (
                                <div key={index} className="p-3 mb-3 border rounded bg-light">
                                    <Row className="align-items-start">
                                        <Col md={11}>
                                            <Row>
                                                <Col md={12} className="mb-2">
                                                    <Form.Label className="small text-muted mb-1">Question ({index + 1})</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="e.g. Are the online programs globally recognized and accredited?"
                                                        value={faq.q || ''}
                                                        onChange={(e) => {
                                                            const newFaqs = [...(data?.faqs || [])];
                                                            newFaqs[index].q = e.target.value;
                                                            onChange('faqs', newFaqs);
                                                        }}
                                                        className="generic-form-control"
                                                    />
                                                </Col>
                                                <Col md={12}>
                                                    <Form.Label className="small text-muted mb-1">Answer</Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={3}
                                                        placeholder="e.g. Yes, Chitkara University Online programs are approved by UGC-DEB, AICTE..."
                                                        value={faq.a || ''}
                                                        onChange={(e) => {
                                                            const newFaqs = [...(data?.faqs || [])];
                                                            newFaqs[index].a = e.target.value;
                                                            onChange('faqs', newFaqs);
                                                        }}
                                                        className="generic-form-control"
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md={1} className="d-flex align-items-center justify-content-end pt-2">
                                            <Button
                                                variant="danger"
                                                size="sm"
                                                disabled={(data?.faqs || []).length <= 1}
                                                onClick={() => {
                                                    const newFaqs = [...(data?.faqs || [])];
                                                    newFaqs.splice(index, 1);
                                                    onChange('faqs', newFaqs);
                                                }}
                                            >
                                                Remove
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>
                            ))}
                        </div>
                    </Col>

                    <SeoFormSection data={data} onChange={onChange} />

                    <Col md={12}>
                        <Button className="mt-4 professional-submit-btn" type="submit">
                            Submit
                        </Button>
                    </Col>
                </Row>
            </Form>
        </Container>
    );
};
